import { envKeysPrivate, envKeysPublic } from '~/config/env.config'

export default function generateEnvs () {
  const config = useRuntimeConfig()

  let privateKeys = {}
  if(import.meta.server) {
    // Only include private keys in SSR mode
    privateKeys = Object.fromEntries(
      Object.entries(envKeysPrivate).map(([key]) => [key, config[key]])
    )
  }

  const publicKeys = Object.fromEntries(
    Object.entries(envKeysPublic).map(([key, value]) => [
      key,
      config.public[key] || value
    ])
  )

  return {
    ...privateKeys,
    ...publicKeys
  }
}
